export const SET_CURRENT_STEP_SUCCESS = 'SET_CURRENT_STEP_SUCCESS';
export const SET_CURRENT_STEP_AND_CONTACT_SUCCESS = 'SET_CURRENT_STEP_AND_CONTACT_SUCCESS';
export const SET_CONFIRMATION_PAGE_TYPE = 'SET_CONFIRMATION_PAGE_TYPE';



export const setCurrentStepSuccess = (step) => {
    return {
        type: SET_CURRENT_STEP_SUCCESS,
        step: step
    }
};

export const setCurrentStep = (step) => {

    return (dispatch) => {
        dispatch(setCurrentStepSuccess(step));
    }
};

export const setConfirmationPageTypeSuccess = (data) => {
    return {
        type: SET_CONFIRMATION_PAGE_TYPE,
        data: data,
    }
};

export const setConfirmationPageType = (data) => {

    return (dispatch) => {
        dispatch(setConfirmationPageTypeSuccess(data));
    }
};


export const setStepsContactSuccess = (step, data) => {
    return {
        type: SET_CURRENT_STEP_AND_CONTACT_SUCCESS,
        step: step,
        data: data,
    }
};

export const setStepAndContact = (step, data) => {

    return (dispatch) => {
        dispatch(setStepsContactSuccess(step, data));
    }
};
